import devSettings from './dev.env.js';
import testSettings from './test.env.js';
import prodSettings from './prod.env.js';
import merge from 'webpack-merge';

let settings = merge({}, prodSettings);

if (process.env.NODE_ENV === 'development') {
  settings = merge(settings, devSettings);
}
if (window.location.href.indexOf('d7mcl0ud.de') > -1) {
  settings = merge(settings, testSettings);
}

export default settings;
